import { GenericService } from './generic.service';
import { OrderHistory } from '@/models';

export class OrganisationOrderHistoryService<T = OrderHistory> extends GenericService<T> {
  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/orders`);
  }
}
